document.addEventListener('DOMContentLoaded', function() {
    
    // Collection Sidebar
    let section = document.getElementById('shopify-section-collection-sidebar');
    let toggleBtn = document.getElementById('toggle-collection-sidebar');
    let sidebar = document.getElementById('collection-sidebar');

    if(section && toggleBtn && sidebar) {
        toggleBtn.onclick = function() {
            section.classList.toggle('open');
        };
    }

    // Klaviyo Popup Form
    const homeownerRadio = document.getElementById('homeownerRadio');
    const tradespersonRadio = document.getElementById('tradespersonRadio');
    const homeownerForm = document.getElementById('klavioForm--homeowner');
    const tradeForm = document.getElementById('klavioForm--trade');

    function toggleForms() {
        if (homeownerRadio.checked) {
            homeownerForm.style.display = 'block';
            tradeForm.style.display = 'none';
        } else if (tradespersonRadio.checked) {
            homeownerForm.style.display = 'none';
            tradeForm.style.display = 'block';
        }
    }

    if (homeownerRadio && tradespersonRadio) {
        homeownerRadio.addEventListener('change', toggleForms);
        tradespersonRadio.addEventListener('change', toggleForms);
    }
});